import React, { useEffect, useState } from "react";
import { Box, Button, Grid, TextField, Typography } from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';
import useStyles from './styles';
import { postDataRequest } from "../../common/commonfunctions";
import { showNotification } from "../../components/Notification/ToastifyNotifications";
import config from "../../config";
import { useGlobalState } from '../../context/GlobalContext';
import { CRMcontactByData, UpdateContact } from "../../Api Mutation/Contact";
import { LoadingPage } from "../LoadingPage/LoadingPage";
import { CreateLinkedinContacts, LinkedinAccountByBusiness } from "../../Api Mutation/LinkedinApi";
import { Autocomplete } from "@material-ui/lab";
import SettingsIcon from '@material-ui/icons/Settings';
import axios from "axios";
import PeopleList from "./PeopleList";

export default function LinkedInFinder({
    history,
    contactId,
    handleClose,
    linkedInAccess
}) {
    const classes = useStyles();
    const globalContext = useGlobalState();
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [jobTitle, setJobTitle] = useState(null);
    const [contactLoading, setContactLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [accountId, setAccountId] = useState(null);
    const [cursor, setCursor] = useState(null);
    const [profiles, setProfiles] = useState([]);
    const [selectedPeople, setSelectedPeople] = useState([]);
    const [isData, setIsData] = useState(false);

    useEffect(() => {
        if (contactId) {
            setContactLoading(true);
            postDataRequest(config.baseURLApi, {
                query: CRMcontactByData,
                variables: {
                    contactid: contactId,
                },
            }).then(res => {
                const result = res?.data?.contact;
                if (res?.errors && res?.errors[0]?.message) {
                    showNotification(res.errors[0].message, 'error');
                } else if (result) {
                    setFirstName(result?.firstname);
                    setLastName(result?.lastname);
                    setCompanyName(result?.organization?.name);
                    setJobTitle(result?.jobid);
                }
                setContactLoading(false);
            });
        }
    }, [contactId]);

    useEffect(() => {
        if (globalContext.globalState.currentLocation.parententityid) {
            setContactLoading(true);
            postDataRequest(config.emailFinderApi, {
                query: LinkedinAccountByBusiness,
                variables: {
                    locationid: globalContext?.globalState?.currentLocation?.entityid,
                },
            }).then((response) => {
                if (response?.errors && response?.errors[0]?.message) {
                    showNotification(response?.errors[0]?.message, 'error');
                    setLoading(false);
                } else if (response?.data?.linkedinAccountByBusiness.length > 0) {
                    const data = response?.data?.linkedinAccountByBusiness;
                    setAccounts(data.map((a) => ({
                        accountid: a.account_id,
                        username: a.username
                    })));
                    setAccountId(data[0]?.account_id);
                    setContactLoading(false);
                } else {
                    setContactLoading(false);
                }
            });
        }
    }, [globalContext.globalState.currentLocation.parententityid]);

    const findResult = async (cursor) => {
        setContactLoading(true);
        const advancedKeywords = {
            first_name: firstName,
            last_name: lastName,
            company: companyName,
            title: jobTitle
        };

        // Remove any key-value pairs where the value is null or undefined
        const filteredAdvancedKeywords = Object.fromEntries(
            Object.entries(advancedKeywords).filter(([key, value]) => value != null && value != '')
        );

        const response = await axios({
            method: 'POST',
            url: `${config.unipileBaseURL}/api/v1/linkedin/search?account_id=${accountId}`,
            headers: {
                'accept': 'application/json',
                'content-type': 'application/json',
                'X-API-KEY': config.unipileAccessToken
            },
            params: {
                limit: 10,
                cursor: cursor
            },
            data: {
                api: 'classic',
                category: 'people',
                advanced_keywords: filteredAdvancedKeywords // Use the filtered object here
            }
        });

        if (response.data.items?.length > 0) {
            setProfiles(prev => {
                const existingIds = new Set(prev.map(chat => chat.id));
                const newChats = response?.data.items.filter(chat => !existingIds.has(chat.id));
                return [...prev, ...newChats];
            });
            setCursor(response.data.cursor);
            setIsData(false)
        } else {
            setIsData(true);
        }
        setContactLoading(false);
    }

    return (
        <>
            {contactLoading ? <LoadingPage /> : ''}
            <Box style={{ marginTop: 30 }}>
                <center>
                    <Typography variant="h4">LinkedIn Finder</Typography>
                    <Typography variant="h2" style={{ color: '#005eb2', fontWeight: 500 }}>Find the LinkedIn Profile</Typography>
                    <Typography variant="h2" style={{ fontWeight: 500 }}>of any professional.</Typography>
                </center>
            </Box>
            <Box className={contactId ? classes.newBox : classes.Box}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            value={accounts?.find((c) => c.accountid === accountId) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            clearIcon={null}
                            options={accounts || []}
                            getOptionLabel={e => e?.username}
                            onChange={(event, newValue) => {
                                setAccountId(newValue?.accountid);
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Select Account *" name="Select Account" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="text"
                            label="Company Name"
                            placeholder="Enter Company Name"
                            variant="outlined"
                            size="small"
                            InputProps={{
                                style: { height: 38 },
                            }}
                            InputLabelProps={{
                                style: { marginTop: 1 },
                            }}
                            value={companyName || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setCompanyName(value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            size="small"
                            type="text"
                            label="First Name"
                            placeholder="Enter a FirstName"
                            variant="outlined"
                            InputProps={{
                                style: { height: 38 },
                            }}
                            InputLabelProps={{
                                style: { marginTop: 1 },
                            }}
                            value={firstName || ''}
                            onChange={(e) => {
                                setFirstName(e.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="text"
                            label="Last Name"
                            placeholder="Enter a LastName"
                            variant="outlined"
                            size="small"
                            InputProps={{
                                style: { height: 38 },
                            }}
                            InputLabelProps={{
                                style: { marginTop: 1 },
                            }}
                            value={lastName || ''}
                            onChange={(e) => {
                                setLastName(e.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="text"
                            label="Job Title"
                            placeholder="Enter Job Title"
                            variant="outlined"
                            size="small"
                            InputProps={{
                                style: { height: 38 },
                            }}
                            InputLabelProps={{
                                style: { marginTop: 1 },
                            }}
                            value={jobTitle || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setJobTitle(value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <center>
                            {accountId !== null ? (
                                <Button
                                    startIcon={<SearchIcon />}
                                    size="small"
                                    variant="contained"
                                    fullWidth
                                    className={classes.emailButton}
                                    disabled={contactLoading}
                                    onClick={() => {
                                        if (
                                            (!companyName || companyName.trim() === '') &&
                                            (!firstName || firstName.trim() === '' || !lastName || lastName.trim() === '')
                                        ) {
                                            showNotification('Please provide first name, last name, or company name.', 'error');
                                        } else {
                                            setProfiles([]);
                                            setCursor(null);
                                            findResult(null);
                                        }
                                    }}
                                >
                                    Search
                                </Button>
                            ) : (
                                <Button
                                    startIcon={<SettingsIcon />}
                                    size="small"
                                    variant="contained"
                                    className={classes.connectButton}
                                    onClick={() => {
                                        if (linkedInAccess) {
                                            history.push(`/app/linkedin/connect-account`)
                                        } else {
                                            showNotification('For access, please contact our customer support team via email at sd@bixjet.com.', 'error');
                                        }
                                    }}
                                >
                                    Connect Account
                                </Button>
                            )}
                        </center>
                    </Grid>
                </Grid>
            </Box>
            <PeopleList
                isData={isData}
                profileData={profiles}
                contactId={contactId}
                cursor={cursor}
                findResult={findResult}
                selectedPeople={selectedPeople}
                setSelectedPeople={setSelectedPeople}
                addToBixjet={() => {
                    setContactLoading(true);
                    const data = selectedPeople.map((a) => ({
                        firstname: a.name.split(' ')?.[0],
                        lastname: a.name.split(' ')?.[1],
                        contactavatar: a.profile_picture_url,
                        street1: a.location,
                        linkedin: a.public_profile_url?.split('?')[0],
                        source: JSON.stringify(['LinkedIn']),
                        status: '3',
                        lifecyclestage: '2',
                        jobid: jobTitle,
                        name: companyName
                    }));
                    postDataRequest(config.baseURLApi, {
                        query: CreateLinkedinContacts,
                        variables: {
                            contactsData: data,
                            ownerid: globalContext?.globalState?.userInfo?.userid,
                            locationid: globalContext.globalState.currentLocation.entityid,
                            createdby: globalContext?.globalState?.userInfo?.userid,
                        },
                    }).then(res => {
                        const result = res?.data?.createLinkedinContacts;
                        if (res?.errors && res?.errors[0]?.message) {
                            showNotification(res.errors[0].message, 'error');
                        } else if (result) {
                            showNotification('Contacts added successfully', 'success');
                            setProfiles([]);
                            setFirstName(null);
                            setLastName(null);
                            setCompanyName(null);
                            setSelectedPeople([]);
                            setJobTitle(null);
                        }
                        setContactLoading(false);
                    });
                }}
                updateContact={(a) => {
                    setContactLoading(true);
                    if (contactId) {
                        postDataRequest(config.baseURLApi, {
                            query: UpdateContact,
                            variables: {
                                contactid: contactId,
                                contactavatar: a.profile_picture_url,
                                street1: a.location,
                                linkedin: a.public_profile_url?.split('?')[0],
                                jobid: jobTitle,
                                ownerid: globalContext?.globalState?.userInfo?.userid,
                                locationid: globalContext.globalState.currentLocation.entityid,
                                updatedby: globalContext?.globalState?.userInfo?.userid,
                            },
                        }).then((res) => {
                            if (res?.errors && res?.errors[0]?.message) {
                                showNotification(res.errors[0].message, 'error');
                            } else if (res?.data?.updateContact) {
                                handleClose();
                                showNotification('Contacts updated successfully', 'success');
                                setProfiles([]);
                                setFirstName(null);
                                setLastName(null);
                                setCompanyName(null);
                                setSelectedPeople([]);
                                setJobTitle(null);
                            }
                            setContactLoading(false);
                        }).catch((err) => {
                            setContactLoading(false);
                            showNotification(err, 'error');
                        });
                    }
                }}
            />
        </>
    );
};